import { ChevronLeft, ChevronRight } from 'lucide-react';
import { formatNumber } from '../../utils/formatters';

/** Rodapé de paginação das tabelas (auditoria: tabela de dados). "1–50 de 312" e anterior/próxima. */
export function Paginacao({ pagina, porPagina, total, aoMudar }: { pagina: number; porPagina: number; total: number; aoMudar: (pagina: number) => void }) {
  if (total <= porPagina) return null;
  const ultima = Math.max(1, Math.ceil(total / porPagina));
  const inicio = (pagina - 1) * porPagina + 1;
  const fim = Math.min(total, pagina * porPagina);
  return (
    <nav aria-label="Paginação" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'var(--space-3)', flexWrap: 'wrap', padding: 'var(--space-3) var(--space-4)', borderTop: '1px solid var(--color-border-default)', fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)' }}>
      <span>{formatNumber(inicio)}–{formatNumber(fim)} de {formatNumber(total)}</span>
      <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
        <button type="button" className="botao-icone" onClick={() => aoMudar(pagina - 1)} disabled={pagina <= 1} aria-label="Página anterior" title="Página anterior">
          <ChevronLeft size={18} />
        </button>
        <button type="button" className="botao-icone" onClick={() => aoMudar(pagina + 1)} disabled={pagina >= ultima} aria-label="Próxima página" title="Próxima página">
          <ChevronRight size={18} />
        </button>
      </div>
    </nav>
  );
}

/** Fatia da lista que aparece na página (pagina começa em 1). */
export function paginar<T>(itens: T[], pagina: number, porPagina: number): T[] {
  return itens.slice((pagina - 1) * porPagina, pagina * porPagina);
}
